/* AMP's widget (BIS.popup.show({ variantId })) loads from the app embed and has
 * no ready event, so an early click polls for it briefly. */
if (!window.backInStockReady) {
  window.backInStockReady = true;

  const whenBIS = (callback, waited = 0) => {
    if (window.BIS?.popup?.show) return callback(window.BIS);
    if (waited >= 5000) {
      console.warn('Back in Stock: the AMP widget did not load. Is the app embed enabled?');
      return;
    }
    setTimeout(() => whenBIS(callback, waited + 100), 100);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-back-in-stock]');
    if (!button) return;
    event.preventDefault();
    const variantId = Number(button.dataset.variantId);
    whenBIS((BIS) => BIS.popup.show(variantId ? { variantId } : undefined));
  });

  document.addEventListener('variant:change', (event) => {
    const { sectionId, variant } = event.detail || {};
    if (!variant) return;
    const scope = (sectionId && document.querySelector(`product-page[data-section="${sectionId}"]`)) || document;
    const soldOut = variant.available === false;
    scope.querySelectorAll('[data-buy-form]').forEach((form) => {
      form.hidden = soldOut;
    });
    scope.querySelectorAll('[data-back-in-stock]').forEach((button) => {
      button.dataset.variantId = variant.id;
      if (!button.closest('[data-sticky-atc]')) button.hidden = !soldOut;
    });
  });
}
